<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div v-if="!modoEdicao">
        <!-- Filtros -->
        <div class="form-edit-page row row-space">
            <div class="form-item-char40">
                <EquipamentoSetorSelect :ckAddTodos="true" v-model:idSelecionado="idSetor"/>
            </div>

            <div class="form-item-char40">
                <EquipamentoGrupoSelect :ckAddTodos="true" v-model:idSelecionado="idGrupo"/>
            </div>
            
            <div class="form-item">
                <EquipamentoFrame v-model:objSelecionado="equipamentoSelecionado"/>
            </div>

            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--docx" @click="exportarDocx" :disabled="isLoading || !lsDadosMain.length" />
            <button type="button" class="buttom-icon--xlsx" @click="exportarXlsx" :disabled="isLoading || !lsDadosMain.length" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>
        
         
        <!-- TABELA -->
<div v-if="lsDadosMain.length > 0" class="table-wrapper">
    <table class="tbl">
        <thead>
            <tr>
                <th>Grupo / Equipamento</th>
                <th>Serviço</th>
                <th class="col-center">KM atual</th>
                <th class="col-center">Última</th>
                <th class="col-center">Próxima</th>
                <th class="col-center">Status</th>
            </tr>
        </thead>

        <tbody>
            <tr v-for="(row, idx) in lsDados" :key="`${row.nmequipamento}-${row.nmservico}-${idx}`">
                <td>
                    <div class="td-title">{{ row.nmequipamento }}</div>
                    <div class="td-sub">
                        {{ row.nmgrupo || '-' }} • Placa: {{ row.placa || '-' }}
                    </div>
                </td>

                <td>
                    <div class="td-title">{{ row.nmservico }}</div>
                </td>

                <td class="col-center td-title">
                    {{ row.kmatual == null ? '-' : Funcoes.formatDecimal(row.kmatual,0) }}
                </td>

                <td class="col-center">
                    <div class="td-mini">
                        {{ row.kmultima == null ? '-' : Funcoes.formatDecimal(row.kmultima,0) }}
                    </div>
                    <div class="td-mini muted">
                        {{ row.dtultima ? Funcoes.formatDateFromJson(row.dtultima) : '-' }}
                    </div>
                </td>

                <td class="col-center">
                    <div class="td-mini">
                        {{ row.kmproxima == null ? '-' : Funcoes.formatDecimal(row.kmproxima,0) }}
                    </div>
                    <div class="td-mini muted">
                        {{ row.dtproxima ? Funcoes.formatDateFromJson(row.dtproxima) : '-' }}
                    </div>
                </td>

                <td class="col-center">
                    <span :class="['badge', row.ckvencido === 'S' ? 'badge-vencido' : 'badge-ok']">
                        {{ row.ckvencido === 'S' ? 'VENCIDO' : 'OK' }}
                    </span>
                </td>
            </tr>

            <tr v-if="isLoading">
                <td colspan="6" class="empty">Carregando...</td>
            </tr>
        </tbody>
    </table>
</div>




    <!-- Paginação (mantém a tua) -->
    <div v-if="showPagination" class="pagination">
        <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
        <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
        <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
        <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
        <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
    </div>


    </div>
</template>

<script setup>
import * as XLSX from 'xlsx';
import { ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import EquipamentoFrame from '@/components/frames/EquipamentoFrame.vue';
import EquipamentoGrupoSelect from '@/selects/EquipamentoGrupoSelect.vue';
import EquipamentoSetorSelect from '@/selects/EquipamentoSetorSelect.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close']);

const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);
const msgAlerta = ref(null);

const equipamentoSelecionado = ref();
const idGrupo = ref(0);
const idSetor = ref(0);

const currentPage = ref(1);
const itemsPerPage = 10;
const lsDadosMain = ref([]);
const showPagination = ref(false);


function closeForm() { emit('close'); }


async function exportarDocx() {
    try {
        if (!lsDadosMain.value?.length) {
            msgAlerta.value = 'ATENÇÃO: Não há dados para exportar.';
            return;
        }

        // Lazy load: só baixa a lib se o usuário clicar
        const { Document, Packer, Paragraph, TextRun, Table, TableRow, TableCell, WidthType } = await import('docx');


        const fileSaver = await import('file-saver');
        const saveAs = fileSaver.default;

        const now = new Date();
        const pad2 = (n) => String(n).padStart(2, '0');
        const dataHora =
            `${pad2(now.getDate())}/${pad2(now.getMonth() + 1)}/${now.getFullYear()} ` +
            `${pad2(now.getHours())}:${pad2(now.getMinutes())}`;

        const titulo = new Paragraph({
            children: [new TextRun({ text: 'RELATÓRIO - ALERTAS DE MANUTENÇÃO', bold: true })],
        });

        const info = new Paragraph({
            children: [
                new TextRun({ text: `Município: ${globalStore.idmunicipio}  |  Emitido em: ${dataHora}`, italics: true }),
            ],
        });

        // Cabeçalho da tabela no DOCX
        const headerRow = new TableRow({
            children: [
                'Grupo', 'Equipamento', 'Placa', 'KM Atual', 'Serviço',
                'KM Última', 'DT Última', 'KM Próxima', 'DT Próxima', 'Vencido'
            ].map((t) => new TableCell({
                children: [new Paragraph({ children: [new TextRun({ text: t, bold: true })] })],
            })),
        });

        // Linhas
        const bodyRows = lsDadosMain.value.map((r) => new TableRow({
            children: [
                r.nmgrupo || '',
                r.nmequipamento || '',
                r.placa || '',
                r.kmatual == null ? '' : String(r.kmatual),
                r.nmservico || '',
                r.kmultima == null ? '' : String(r.kmultima),
                r.dtultima ? Funcoes.formatDateFromJson(r.dtultima) : '',
                r.kmproxima == null ? '' : String(r.kmproxima),
                r.dtproxima ? Funcoes.formatDateFromJson(r.dtproxima) : '',
                r.ckvencido === 'S' ? 'SIM' : 'NÃO',
            ].map((val) => new TableCell({
                children: [new Paragraph(String(val))],
            })),
        }));

        const table = new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [headerRow, ...bodyRows],
        });

        const doc = new Document({
            sections: [
                {
                    children: [titulo, info, new Paragraph(''), table],
                },
            ],
        });

        const blob = await Packer.toBlob(doc);

        const y = now.getFullYear();
        const m = pad2(now.getMonth() + 1);
        const d = pad2(now.getDate());
        saveAs(blob, `alertas_manutencao_${y}${m}${d}.docx`);
    } catch (err) {
        msgAlerta.value = `ATENÇÃO: Falha ao exportar DOCX: ${err?.message || err}`;
    }
}


function exportarXlsx() {
    try {
        if (!lsDadosMain.value?.length) {
            msgAlerta.value = 'ATENÇÃO: Não há dados para exportar.';
            return;
        }

        // ---- 1) Monta "texto dos filtros" (não quebra se algum estiver vazio)
        const filtroSetor = idSetor.value
            ? 'dados setor aqui' // (equipamentoSetorSelecionado.value.nmsetor || equipamentoSetorSelecionado.value.nome || `ID ${equipamentoSetorSelecionado.value.id}`)
            : 'Todos';

        const filtroGrupo = idGrupo.value
            ? 'dados grupo aqui' // (equipamentoGrupoSelecionado.value.nmgrupo || equipamentoGrupoSelecionado.value.nome || `ID ${equipamentoGrupoSelecionado.value.id}`)
            : 'Todos';

        const filtroEquip = equipamentoSelecionado.value
            ? equipamentoSelecionado.value.nmequipamento
            : 'Todos';

        // Data/hora (bem simples e ok pra POC)
        const now = new Date();
        const pad2 = (n) => String(n).padStart(2, '0');
        const dataHora =
            `${pad2(now.getDate())}/${pad2(now.getMonth() + 1)}/${now.getFullYear()} ` +
            `${pad2(now.getHours())}:${pad2(now.getMinutes())}`;

        // ---- 2) Linhas do "cabeçalho do relatório" (AOA)
        // A tabela vai começar na linha 6 (index 5), ou seja, origin A6.
        const headerAoa = [
            ['RELATÓRIO - ALERTAS DE MANUTENÇÃO'],
            [`Município: ${globalStore.idmunicipio}`, `Emitido em: ${dataHora}`],
            [`Filtros - Setor: ${filtroSetor}`],
            [`Filtros - Grupo: ${filtroGrupo}`],
            [`Filtros - Equipamento: ${filtroEquip}`, `Total de registros: ${lsDadosMain.value.length}`],
            [] // linha em branco antes da tabela
        ];

        // Cria a planilha com esse cabeçalho
        const ws = XLSX.utils.aoa_to_sheet(headerAoa);

        // ---- 3) Dados (tabela) - use lsDadosMain (lista completa)
        const rows = lsDadosMain.value.map((r) => ({
            'Grupo': r.nmgrupo || '',
            'Equipamento': r.nmequipamento || '',
            'Placa': r.placa || '',
            'KM Atual': r.kmatual ?? null,
            'Serviço': r.nmservico || '',
            'KM Última': r.kmultima ?? null,
            'DT Última': r.dtultima ? Funcoes.formatDateFromJson(r.dtultima) : '',
            'KM Próxima': r.kmproxima ?? null,
            'DT Próxima': r.dtproxima ? Funcoes.formatDateFromJson(r.dtproxima) : '',
            'Vencido': r.ckvencido === 'S' ? 'SIM' : 'NÃO',
            'Alerta': r.ckalerta === 'S' ? 'SIM' : 'NÃO',
        }));

        // Adiciona a tabela a partir da linha 7 (A7) -> porque A6 é a linha em branco
        XLSX.utils.sheet_add_json(ws, rows, { origin: 'A7' });

        // ---- 4) Melhorias visuais (largura de colunas)
        ws['!cols'] = [
            { wch: 18 }, // Grupo
            { wch: 32 }, // Equipamento
            { wch: 12 }, // Placa
            { wch: 10 }, // KM Atual
            { wch: 28 }, // Serviço
            { wch: 10 }, // KM Última
            { wch: 12 }, // DT Última
            { wch: 12 }, // KM Próxima
            { wch: 12 }, // DT Próxima
            { wch: 10 }, // Vencido
            { wch: 10 }, // Alerta
        ];

        // (Opcional, mas fica lindo) mescla o título na primeira linha (A1 até K1)
        ws['!merges'] = ws['!merges'] || [];
        ws['!merges'].push({ s: { r: 0, c: 0 }, e: { r: 0, c: 10 } }); // A1..K1

        // ---- 5) Congelar linhas: congela até a linha 7 (onde fica o cabeçalho da tabela)
        // Como a tabela começa em A7, o cabeçalho da tabela fica na linha 7.
        // ySplit=6 congela as linhas 1..6 (título + filtros + linha em branco),
        // e deixa a linha 7 como primeira linha rolável? (na prática, cabeçalho fica visível pois está no topo da tabela)
        //
        // Se você quiser congelar até incluir a linha 7 (mantendo o cabeçalho da tabela SEMPRE visível),
        // use ySplit=7 e topLeftCell='A8'.
        ws['!freeze'] = { xSplit: 0, ySplit: 7, topLeftCell: 'A8', activePane: 'bottomLeft', state: 'frozen' };

        // ---- 6) Workbook + download
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Alertas');

        const y = now.getFullYear();
        const m = pad2(now.getMonth() + 1);
        const d = pad2(now.getDate());
        const fileName = `alertas_manutencao_${y}${m}${d}.xlsx`;

        XLSX.writeFile(wb, fileName);
    } catch (err) {
        msgAlerta.value = `ATENÇÃO: Falha ao exportar XLSX: ${err?.message || err}`;
    }
}


function updatePaginatedData() {
    const startIndex = (currentPage.value - 1) * itemsPerPage;
    const endIndex = (startIndex + itemsPerPage);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

async function lerDados() {
    try {
        msgAlerta.value = null;
        isLoading.value = true;
        
        const payload = {
            idmunicipio: globalStore.idmunicipio,
            idequipamento: equipamentoSelecionado.value?.id,
            idequipamentogrupo: idGrupo.value,
            idequipamentosetor: idSetor.value,
            ativo: 'S',
            idlogin: globalStore.idlogin,
        };

        const req = await Api.genericPost('/dados/frota/manutencao/status', payload);
        lsDadosMain.value = req || [];
        currentPage.value = 1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage);
        updatePaginatedData();
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}

</script>


<style scoped>
.tbl {
    width: 100%;
    border-collapse: collapse;
}

.tbl thead th {
    text-align: left;
    font-size: 12px;
    color: #666;
    font-weight: bold;
    padding: 10px 8px;
    border-bottom: 1px solid #ececec;
}

.tbl tbody td {
    padding: 10px 8px;
    border-bottom: 1px solid #f0f0f0;
    vertical-align: middle;
}

.tbl tbody tr:hover {
    background: #a3c4c2;
}

.col-center {
    text-align: center;
}

.td-title {
    font-weight: bold;
    color: #222;
}

.td-sub {
    color: #777;
}

.td-mini {
    font-weight: bold;
}

.muted {
    color: #777;
    font-weight: bold;
}

.badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 900;
    border: 1px solid transparent;
    letter-spacing: 0.3px;
}

.badge-vencido {
    color: #b00020;
    background: #ffe9ec;
    border-color: #ffd0d7;
}

.badge-ok {
    color: #1b5e20;
    background: #e7f7ea;
    border-color: #ccefd4;
}

.empty {
    text-align: center;
    padding: 14px 8px;
    color: #777;
    font-weight: 800;
}

.empty-box {
    background: #fff;
    border: 1px dashed #ddd;
    border-radius: 10px;
    padding: 14px 12px;
    color: #777;
    font-weight: 800;
    text-align: center;
}

</style>